import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Modal,
} from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'

export const SetupContextConfirmModal = ({contextPk, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const [errorText, updateErrorText] = useState(null)

  const startSetupTask = async () => {
    try {
      await client.post(
        "/account/admin_lti13.setupContext/-/", {
          context_pk: contextPk,
        })
      toast.success("Setup task started successfully.")
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(!show)
      updateErrorText(null)
    } catch (err) {
      if (err.response.status === 500) {
        console.log('error: ', err.response)
        toast.error(`${err.response.statusText} ${err.response.data.error}`)
      } else {
        updateErrorText(err.response.data.error)
      }
    }
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Setup Context</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <h4 className='text-center'>Start task to set up context from parent context?</h4>
        <div className='text-center'>
            <div
            className="btn btn-success btn-myed btn-success-myed mr-2"
            onClick={() => startSetupTask()}
            >
            Confirm
            </div>
            <div
                className="btn btn-danger btn-myed btn-danger-myed"
                onClick={() => toggle(!show)}
            >
            Cancel
            </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

SetupContextConfirmModal.propTypes = {
  contextPk: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
